module.exports = __webpack_public_path__ + "img/x431_3.a8f36245.jpg";